import type { PaginatedLocalGiftCardDto } from "common/models/api/models/PaginatedLocalGiftCardDto";
import { useQuery, UseQueryOptions, UseQueryResult } from "react-query";
import { Queries } from "ui/query/queries";
import { giftcardsApi } from "../api/giftcardsApi";

export interface UseGetLocalGiftCardsParams {
    query?: string;
    page: number;
    pageSize?: number;
    status?: boolean;
    type?: string;
    partner?: string;
}

export default function useGetLocalGiftCards(
    { query, page, pageSize = 10, status, type, partner }: UseGetLocalGiftCardsParams,
    options?: UseQueryOptions<PaginatedLocalGiftCardDto, unknown, PaginatedLocalGiftCardDto, (string | undefined | boolean | number)[]>,
): UseQueryResult<PaginatedLocalGiftCardDto> {
    return useQuery(
        [Queries.GIFTCARDS_FIND_ALL, query, page, pageSize, status, type, partner],
        async () => {
            const res = await giftcardsApi.getLocalGiftCards({ query, page, pageSize, status, type, partner });
            return res.data;
        },
        { ...options },
    );
}
